<template>
  <div
    class="site-in"
    ref="refRoot"
  >
    <div class="bg bg-gradient" />

    <div class="bg bg-blocks">
      <div
        v-for="row in numRows"
        class="row"
        :key="`site-in-row-${row}`"
      >
        <div
          v-for="col in numCols"
          class="col"
          :key="`site-in-col-${row}-${col}`"
        >
          <div class="block" />
        </div>
      </div>
    </div>

    <div class="wrap">
      <TheLogo class="icon" />
      <!-- <Spinner /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { SITE_IN_DURATION } from "@/config"
// import IconLogo from "@/icons/logo-small.svg?component"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const numRows = 4
const numCols = 6

const animateSiteIn = function () {
  const tl = $gsap.timeline()

  const q = $gsap.utils.selector(refRoot.value)

  let rows = q(".row")
  rows = [...rows].reverse()

  tl.add("black")
  for (let idx = 0; idx < rows.length; idx++) {
    const row = rows[idx]
    const block = row.querySelectorAll(".block")

    tl.to(
      block,
      {
        x: 0,
        duration: 0.5,
        stagger: 0.1,
      },
      `black+=${idx * 0.15}`
    )
  }

  tl.to(q(".icon"), { opacity: 0, duration: 0.5 }, "-=0.5")

  tl.add("out")
  tl.set(q(".bg-gradient"), { opacity: 0 }, "out")
  for (let idx = 0; idx < rows.length; idx++) {
    const row = rows[idx]
    const block = row.querySelectorAll(".block")

    tl.to(
      block,
      {
        x: "101%",
        duration: 0.5,
        stagger: 0.1,
      },
      `out+=${idx * 0.15}`
    )
  }

  let targetDuration = SITE_IN_DURATION * 0.8
  tl.timeScale(tl.duration() / targetDuration)
}

const firstTime = ref(true)
usePageEnter(() => {
  if (!firstTime.value) {
    return
  }
  // console.log("usePageEnter")
  firstTime.value = false
  animateSiteIn()
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.site-in {
  @include fill();
  @include flex(column);
  position: fixed;
  z-index: 1000;
  pointer-events: none;
}

.bg {
  @include fill();
}

.bg-gradient {
  // background: linear-gradient(
  //   180deg,
  //   #ef9fcc -3.57%,
  //   #e0a1a3 43.32%,
  //   #f58556 101.75%
  // );
  @include animatedBg();
}

.bg-blocks {
  @include flex(column, center, stretch);

  .row {
    flex: 1;
    @include flex(row, stretch, stretch);
  }
  .col {
    position: relative;
    flex: 1;
    overflow: hidden;
  }
  .block {
    @include fill;
    background: black;
    transform: translateX(calc(-100% - 1px));
  }
}

.wrap {
  position: relative;
}

.icon {
  position: relative;
  height: 3.5rem * 2;
}
</style>
